import React from "react";
import DashHeader from "./DashHeader";
import Sidebar from "./sidebar/Sidebar";
import "./dashboard.css";
import { useMediaQuery } from "@mui/material";
import { getUser } from "./utils/common";

const Dashboard = ({ children }) => {
  const isTablet = useMediaQuery("(max-width: 960px)");
  const user = getUser();
  const isBarberB = user && user.length > 0 && user[0]?.type === "BARBER_B";
  
  return (
    <div className="dashboard flex ">
      <DashHeader />
      {!isTablet && !isBarberB && <Sidebar />}
      <div className="dashboard_content w-full"> {children}</div>
    </div>
  );
};

export default Dashboard;
